import { useCallback } from 'react';
import { VariaveisAmbiente } from 'config';
import { useApiBase } from '../../base/api-base';

export function useGetLog() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getLog = useCallback(
        (usuarioId: number) =>
            invocarApi({
                url: `/api/v1/log?sistemaId=${usuarioId}`,
                method: 'GET',
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.apiClickupLicUrl,
                timeout: 30000
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getLog,
    };
}
